import React, {useState, useEffect} from "react"
import cogoToast from "cogo-toast"
import Skeleton from 'react-loading-skeleton'
import UserFormWizard from "../../../user-form-wizard/UserFormWizard"
import { useSelector, shallowEqual, useDispatch } from "react-redux"
import * as handlers from "../../../_redux/selected-user/selectedUserHandlers";

const EditUser = ({match, history, location}) => {

  const query = new URLSearchParams(location.search);
  const [tab, setTab] = useState(+query.get('tab'));
  const selectedUser = useSelector(({selectedUser}) => {
      const data = selectedUser?.data?.profile?.basic?.userId === match.params.userId ? selectedUser.data : null;
      return  {...selectedUser, data};
  }, shallowEqual);

  // Redux dispatch
  const dispatch = useDispatch();
  let userData = null; 

  /* Update userData object with user profile data */
  if (selectedUser?.data?.profile){
      const profile = selectedUser.data.profile;
      userData = {tab1: {basic: profile?.basic, identificationData: profile?.identificationData}};
      userData.tab2 = {personalData: profile?.personalData, trustData: profile?.trustData,  addressData: profile?.addressData};
      userData.tab3 = {employmentData: profile?.employmentData, investmentData: profile?.investmentData, complianceData: profile?.complianceData}
  }

  useEffect(() => {
    // Fetch User profile
    dispatch(handlers.fetchUserProfile(match.params.userId));
  }, [dispatch, match.params.userId]);

  
  /* Notification Pop up */
  useEffect(() => {
    if (selectedUser?.notification){
      cogoToast[selectedUser.notification.type](selectedUser.notification.message);
      dispatch(handlers.clearNotification());

      if (selectedUser.notification.type === "success"){
        history.push(`/users/view/${match.params.userId}`)
      }
    }
  });

  /* Submit user Data */
  const submitData = data => {
    dispatch(handlers.updateUserProfile(match.params.userId, {...selectedUser.data.profile, ...data.tab1, ...data?.tab2, ...data?.tab3, meta: selectedUser.data.profile}));
  }

    return ( userData ? 
                <UserFormWizard 
                    tab={tab} 
                    setTab={setTab} 
                    data={userData}
                    isLoading={selectedUser?.isLoading}
                    submitData={submitData} 
                />
                :
                <div className="container">
                  <div className="card card-custom card-white pb-5" >
                    <center>
                      <Skeleton height={50} count={4} width="20%" style={{margin:"2rem 2rem 5rem 2rem"}} />
                      <Skeleton height={30} width="20%" count={16} style={{margin:"1rem 10%"}} />
                    </center>
                  </div>
                </div>
            )
    
    
}


export default EditUser;